<template>
    <div style="margin-left:12.5%;margin-right:12.5%;background-color:#ffffff;border:1px solid #eeeeee;">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
        </el-breadcrumb>
        <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card" class="data_center_tabs"  v-if="is_display!=0">
            <el-tab-pane label="详细结果" name="first">
                <pain-lists ref="pain_lists" v-if="display_details && get_data_flag" 
                :results_mode="results_mode" 
                :task_id="task_id" 
                :painspot_info="painspot_info" 
                :activeIndex="painspot_info[0]['name']" 
                :painspot_details="painspot_details"
                :depart_options="depart_options"
                :rank_options="rank_options"
                :display_ranks="display_ranks"
                :logged_role="logged_role"></pain-lists>
            </el-tab-pane>
            <el-tab-pane label="汇总结果" name="second">
                <pain-lists ref="pain_lists" v-if="display_summary && get_data_flag" 
                :results_mode="results_mode" 
                :task_id="task_id" 
                :painspot_info="painspot_info" 
                :activeIndex="painspot_info[0]['name']" 
                :painspot_details="painspot_details"
                :display_ranks="display_ranks"></pain-lists>
            </el-tab-pane>
            <el-tab-pane label="TOP建言献计" name="third">
                <pain-lists ref="pain_lists" v-if="display_top_advices && get_data_flag" 
                :results_mode="results_mode" 
                :task_id="task_id" 
                :painspot_info="painspot_info" 
                :activeIndex="painspot_info[0]['name']" 
                :painspot_details="painspot_details"
                :display_ranks="display_ranks"></pain-lists>
            </el-tab-pane>
        </el-tabs>
        <div v-else>
            <span>{{ no_data_text }}</span>
        </div>
    </div>
</template>

<script>
import painLists from "./JianKang_DataCenterList.vue";
import getdata from "@/api/getData.js";
export default {
    created() {
        this.login_random_series = this.$route.query.id;
        this.task_id = this.$route.query.task;
        let params;
            params = {
                login_random_series: this.login_random_series,
                task_id: this.task_id,
            }
        if((typeof(this.login_random_series) != "undefined") && (this.login_random_series != '')){
            getdata.getListP("checkLoginRandomSeries", params)
                .then((resp) => {
                    if(resp.data.code != 200){
                        this.$router.push({
                            path: '/404',
                        });
                    }else{
                        this.logged_user = resp.data.data;
                        // 使用固定URL登录的用户，获取职级信息，并根据本人的职级过滤展示下级的数据
                        this.get_rank_info();
                    }
                })
                .catch(() => {
                    this.$router.push({
                        path: '/JKlogin',
                    });
                })

            // this.is_router = false;
        }else{
            getdata.getList("checklogin")
                .then((resp) => {
                    this.logged_role = resp.data.usertype;
                    this.task_id = resp.data.task_id;
                    if(this.logged_role=='ceo'){
                        this.activeName = 'first';
                        this.display_ranks = 'ALL';     // ceo可以看下所有职级的内容
                        this.is_display = 1;
                    }else if(this.logged_role=='company' || this.logged_role=='admin') {
                        this.$router.push({
                            path: '/404',
                        });
                    }                    
                    // 获取top痛点列表
                    this.get_painspot_list(this.task_id);
                })
                .catch(() => {
                    this.$router.push({
                        path: '/JKlogin',
                    });
                })
        }
    },
    data() {
        return {
            logged_role: '',
            activeName: '',
            results_mode: 'details',
            isUpdateResults: false,
            task_id: null,
            display_details: true,
            display_summary: false,
            display_top_advices: false,
            painspot_info: [{'name': ''}],
            painspot_details: null,
            is_display: 0,
            depart_options: [],
            rank_options: [],
            login_random_series: null,
            display_ranks: '',      // 下级rank信息
            no_data_text: '',
            get_data_flag: false,
        }
    },
    components: {
        painLists,
    },
    methods: {
        get_rank_info() {
            let params;
            params = {
                login_random_series: this.login_random_series,
                task_id: this.task_id,
            }
            getdata.getListP("getRankInfo", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.display_ranks = resp.data.display_ranks.join('|');     //不同的rank使用|合并
                    this.is_display = resp.data.is_display;
                    if(this.is_display == 0) {
                        this.no_data_text = '暂无数据。';
                        return;
                    }else{
                        this.activeName = 'first';
                        // 获取top痛点列表
                        this.get_painspot_list(this.task_id);
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        get_painspot_list(task_id) {
            let params;
            params = {
                task_id: task_id,
                display_ranks: this.display_ranks,
            }
            
            getdata.getListP("getPainSpotList", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.painspot_info = resp.data.painspot_info;
                    if(this.painspot_info.length>0){
                        this.get_fully_data(this.painspot_info[0]['name'], "getDataDetailsByPainSpot", task_id);
                    }
                    // if(this.activeName=='first'){
                    //     this.get_fully_data(this.painspot_info[0].name, "getDataDetailsByPainSpot", task_id);
                    // }else if(this.activeName=='third'){
                    //     this.get_fully_data(this.painspot_info[0].name, "getDataAdvicesByPainSpot", task_id);
                    // }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        get_fully_data(painspot, api_name, task_id) {
            // const loading = this.$loading({
            //     lock: true, // lock的修改符--默认是false
            //     text: '正在加载，请稍后...', // 显示在加载图标下方的加载文案
            //     spinner: 'el-icon-loading', // 自定义加载图标类名
            //     background: 'rgba(0, 0, 0, 0.7)', // 遮罩层颜色
            // })
            let params;
            params = {
                painspot: painspot,
                task_id: task_id,
                display_ranks: this.display_ranks,
            }
            
            getdata.getListP(api_name, params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.painspot_details = resp.data.painspot_details;
                    if(this.results_mode=="details") {
                        this.depart_options = resp.data.depart_options;
                        this.rank_options = resp.data.rank_options;
                    }
                    this.get_data_flag = true;
                }
                // loading.close();
            })
            .catch(err => {
                console.log(err);
                // loading.close();
            });
        },
        handleClick(tab) {
            this.get_data_flag = false;
            // console.log("func handleClick.");
            if(tab.label=='详细结果'){
                this.results_mode = 'details'; 
                this.display_details = true; 
                this.display_summary = false;
                this.display_top_advices = false;
                // this.$refs.pain_lists.get_painspot_list(this.task_id, "details");
                this.get_fully_data(this.painspot_info[0]['name'], "getDataDetailsByPainSpot", this.task_id);
            }else if(tab.label=='汇总结果'){
                this.results_mode = 'summary';
                this.display_details = false; 
                this.display_summary = true;
                this.display_top_advices = false;
                // this.$refs.pain_lists.get_painspot_list(this.task_id, "summary");
                this.get_fully_data(this.painspot_info[0]['name'], "getDataSummaryByPainSpot", this.task_id);
            }else{
                this.results_mode = 'top_advices';
                this.display_details = false; 
                this.display_summary = false;
                this.display_top_advices = true;
                // this.$refs.pain_lists.get_painspot_list(this.task_id, "top_advices");
                this.get_fully_data(this.painspot_info[0]['name'], "getDataAdvicesByPainSpot", this.task_id);
            }
        },
    },
}
</script>

<style scoped>
.data_center_tabs /deep/ .el-tabs__content {
    margin-top: 0px;
}
::v-deep .el-tabs__item {
    font-size: 20px;
    height: 50px;
    line-height: 50px;
}
.el-breadcrumb {
    font-size: 20px;
    border-left: solid 6px #606266;
    padding-left: 15px;
    margin-bottom: 50px;
}
</style>